import { render, staticRenderFns } from "./chooseOrgTree.vue?vue&type=template&id=0cf24c32&scoped=true"
import script from "./chooseOrgTree.vue?vue&type=script&lang=js"
export * from "./chooseOrgTree.vue?vue&type=script&lang=js"
import style0 from "./chooseOrgTree.vue?vue&type=style&index=0&id=0cf24c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf24c32",
  null
  
)

export default component.exports